import { useTranslation } from "react-i18next";
import { light } from "../../../../../../utils/theme/colors/light";
import { Priority } from "../../../../../../utils/enums/priority";

export const useGradientColor = (): {
    id: number;
    name: string;
    color: string;
    priority: Priority;
}[] => {
    const { t } = useTranslation()
    return [
        {
            id: Priority.URGENT,
            color: light.color19,
            name: t('general.priority.urgent'),
            priority: Priority.URGENT
        },
        {
            id: Priority.HIGH,
            color: light.color29,
            name: t('general.priority.high'),
            priority: Priority.MEDIUM
        },
        {
            id: Priority.MEDIUM,
            color: light.color8,
            name: t('general.priority.medium'),
            priority: Priority.MEDIUM
        },
        {
            id: Priority.LOW,
            color: light.color10,
            name: t('general.priority.suggestion'),
            priority: Priority.LOW
        },
    ]
}